export default __webpack_public_path__ + "static/media/big_check.5b9fbd8d.svg";